// externals
import type { Reducer } from 'redux';

// libraries
import type { CalculationDetailsState } from '@makemydeal/dr-dash-types';
import { initActionTypes } from '@makemydeal/dr-shared-store';
import { actions as offerReduxActionTypes, paymentActionTypes } from '@makemydeal/dr-offer-redux';
import { UPDATE_IS_TARGET_OUT_OF_POCKET } from '../actionTypes/calculationDetailsActionTypes';
import { PAYMENT_RECEIVED } from '../actionTypes/deskingActionTypes';

const { INIT_PENCIL_SUCCESS } = initActionTypes;
const { CLEAR_TAX_AMOUNTS, RESET_TAX_OVERRIDES } = offerReduxActionTypes;
const { UPDATED_USE_CALCULATED_GOV_FEES } = paymentActionTypes;

export type CalculationDetailsReducer = Reducer<CalculationDetailsState>;

export const reducer: CalculationDetailsReducer = (state: CalculationDetailsState = {}, action: any) => {
    switch (action.type) {
        case INIT_PENCIL_SUCCESS: {
            return {
                ...state,
                ...action.payload.calculationDetails
            };
        }
        case CLEAR_TAX_AMOUNTS:
        case RESET_TAX_OVERRIDES: {
            // Persist the include-default-taxes intent in the slice that gets saved
            // (createCalculationDetailsForOfferSave reads this), so a cleared deal reloads with taxes
            // suppressed. Clear -> false, Reset -> true. Mirrors the offer-redux payment reducer.
            return {
                ...state,
                payment: {
                    ...state.payment,
                    calculationSettings: {
                        ...state.payment?.calculationSettings,
                        useDealerDefaultTaxes: action.type === RESET_TAX_OVERRIDES
                    }
                }
            };
        }
        case UPDATE_IS_TARGET_OUT_OF_POCKET: {
            const isTargetOutOfPocket = action.payload || false;
            const cashApplyMethod = isTargetOutOfPocket ? 'AddCashOffsetToPrice' : '';
            return {
                ...state,
                payment: {
                    ...state.payment,
                    calculationSettings: {
                        ...state.payment?.calculationSettings,
                        cashApplyMethod
                    }
                }
            };
        }
        case UPDATED_USE_CALCULATED_GOV_FEES: {
            return {
                ...state,
                payment: {
                    ...state.payment,
                    calculationSettings: {
                        ...state.payment?.calculationSettings,
                        useCalculatedGovFees: action.payload
                    }
                }
            };
        }
        case PAYMENT_RECEIVED: {
            if (action.meta?.isStalePaymentResponse) return state;

            const leasePayload = action.payload.lease;

            if (!leasePayload) return state;

            return {
                ...state,
                payment: {
                    ...state.payment,
                    isFirstPaymentCapitalized: leasePayload.firstPaymentCapitalized ?? false
                }
            };
        }
        default: {
            return state;
        }
    }
};
